import React from 'react';
import Navbar from '../../components/Navbar2';
import Contact from '../../components/Contact';
import './index.css';

const OurStoryPage = () => {
  return (
    <div className="story-page">
      <Navbar />

      {/* Hero Section */}
      <div className="story-hero">
        <div className="story-hero-overlay" />
        <div className="story-hero-content">
          <p className="story-hero-label">Our Journey</p>
          <h1 className="story-hero-title">
            Where Luxury Meets
            <br />
            Innovation
          </h1>
          <p className="story-hero-sub">
            Redefining luxury living through exquisite hospitality, forward-thinking investment, and a community built on shared values.
          </p>
        </div>
      </div>

      {/* Intro Section */}
      <div className="story-intro-section">
        <div className="story-intro-inner">
          <p className="story-intro-label">Who We Are</p>
          <h2 className="story-intro-title">
            A Legacy Built on Vision,
            <br />
            Community & Innovation
          </h2>
          <p className="story-intro-text">
            From a bold idea to a curated ecosystem of luxury living — every chapter of our story is shaped by a commitment to excellence, purpose, and the people who believe in a better way to live.
          </p>
        </div>
      </div>

      {/* Story Sections */}
      <div className="story-sections-wrap">
        {/* Chapter 1 - Text Left, Image Right */}
        <div className="story-hs-section">
          <div className="story-hs-text">
            <p className="story-hs-label">Chapter 01</p>
            <h2 className="story-hs-title">A Vision Beyond Wealth</h2>
            <p className="story-hs-desc">
              At Luxe Unbounded, we believe that true luxury transcends material wealth — it's about experiences, innovation, and community. Our journey began with a simple vision: to redefine luxury living by blending exquisite hospitality with forward-thinking investment opportunities.
            </p>
          </div>
          <div className="story-hs-image">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Four-story-1.webp?alt=media&token=68086d63-f9e3-48b8-b8bb-7525dd778d89"
              alt="A Vision Beyond Wealth"
            />
          </div>
        </div>

        {/* Chapter 2 - Image Left, Text Right */}
        <div className="story-hs-section">
          <div className="story-hs-image">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Four-story-2.webp?alt=media&token=2a54ab41-209c-4261-abd2-2026a813ed9d"
              alt="A Curated Community"
            />
          </div>
          <div className="story-hs-text">
            <p className="story-hs-label">Chapter 02</p>
            <h2 className="story-hs-title">A Curated Community</h2>
            <p className="story-hs-desc">
              We're more than just a collection of stunning properties — we're a carefully curated community where passion, purpose, and exclusivity intersect. Membership is not determined solely by financial means but by a shared commitment to quality, sustainability, and groundbreaking innovation.
            </p>
          </div>
        </div>

        {/* Chapter 3 - Text Left, Image Right */}
        <div className="story-hs-section">
          <div className="story-hs-text">
            <p className="story-hs-label">Chapter 03</p>
            <h2 className="story-hs-title">Continuous Evolution</h2>
            <p className="story-hs-desc">
              Our story is one of continuous evolution. Whether you're joining us as a partial owner, integrating your property through our Partner Property model, or experiencing our signature services firsthand, you become part of a narrative that celebrates both tradition and transformation.
            </p>
          </div>
          <div className="story-hs-image">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Four-story-3.webp?alt=media&token=74c6c0c4-89f2-411d-bcbb-c089881c1145"
              alt="Continuous Evolution"
            />
          </div>
        </div>
      </div>

      <Contact />
    </div>
  );
};

export default OurStoryPage;
